import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ds-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent {

  constructor(private route: Router,) {

  }

  title ="StarterKit";

  routetest(){
    this.route.navigateByUrl('test1');
  }
}
